import React, { FC } from 'react';
import Modal from 'components/shared/Modal';
import Form from 'app/modules/posts/modules/createContentPlan/components/Form';
import { ModalRouteProps } from 'context/ModalRouter';
import { useToast } from 'app/hooks/useToast';
import { useDispatch } from 'react-redux';
import { useMutation } from 'react-query';
import { PageThunk } from 'modules/page/pageActions';
import { useTranslation } from 'react-i18next';
import { usePage } from 'modules/page/pageSelector';
import ContentPlanApi from 'app/api/contentPlan';

type Props = ModalRouteProps;

const CreateContentPlanPage: FC<Props> = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const toast = useToast();
  const { pages } = usePage();
  const { mutateAsync, isLoading } = useMutation(ContentPlanApi.create, {
    onSuccess: () => {
      toast(t('contentPlanSuccessfullyCreated'), 'success');
      props.modalManager.close();
      dispatch(PageThunk.requestPages());
    },
    onError: () => {
      toast(t('somethingWentWrongTryAgain'), 'error');
    },
  });

  return (
    <Modal
      modalManager={props.modalManager}
      isContentHeightAutoResizable={false}
    >
      <Modal.Header title={t('createNewContentPlan')} />
      <Form onSubmit={mutateAsync} isLoading={isLoading} profiles={pages} />
    </Modal>
  );
};

export default CreateContentPlanPage;
